import type { DropdownIndicatorProps, GroupBase } from 'react-select';
import { VpIcon } from '@vtmn-play/react/headless';
import { components } from 'react-select';

export function DropdownIndicator<T>(props: DropdownIndicatorProps<T, true, GroupBase<T>>) {
  return (
    <components.DropdownIndicator {...props}>
      <VpIcon name="chevron-down" />
    </components.DropdownIndicator>
  );
};
